import { Routes, Route, Outlet } from "react-router-dom";
import ServiceRequestContextProvider from "../context/ServiceRequestContextProvider";
import ServiceRequestList from "../pages/ServiceRequestList";
import ServiceRequestDetails from "../pages/ServiceRequestDetails";
import NewServiceRequest from "../pages/NewServiceRequest";

export default function ServiceRequestRoutes() {
  return (
    <>
      <ServiceRequestContextProvider>
        <Routes>
          <Route path="/list" element={<ServiceRequestList />} />
          <Route path="/cadastro" element={<NewServiceRequest />} />
          <Route path="/:id" element={<ServiceRequestDetails />} />
        </Routes>
        <Outlet />
      </ServiceRequestContextProvider>
    </>
  );
}
